import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import PropTypes from 'prop-types';

/**
 * This is a wrapper of the MUI Tooltip which read the error details received by SAP APIs and display a message accordingly.
 * @type {React.ForwardRefExoticComponent<React.PropsWithoutRef<TooltipWrapperIssue.propTypes> & React.RefAttributes<unknown>>}
 */
export const TooltipWrapperIssue = React.forwardRef((props, ref) => {
    let message = '';
    const statusCode = props.error?.code;

    let messageFromBody = '';
    try {
        messageFromBody = `[${JSON.parse(props.error?.body)?.error?.message?.value}]`;
    } catch {
        // Do nothing
    }

    if (statusCode === 401) {
        message = 'You are not authorized to get the information. Please contact your administrator.';
    } else if (statusCode === 500) {
        message = `There's a temporary connection issue. Please try again later or contact your administrator. ${messageFromBody}`;
    } else if (statusCode === 400) {
        message = `There's an issue with the request. Please contact your administrator [${statusCode}]`;
    } else if (statusCode === 1002) {
        message = `The Spender or Requester field needs to be completed to allow the system to check and return options for this field.`;
    } else {
        message = `There's an issue with the system. Please contact your administrator [${statusCode}]`;
    }

    return (
        <Tooltip title={message} placement={'top'} open={props.open} onClose={props.onClose} arrow enterNextDelay={500} leaveDelay={3000} ref={ref}>
            {props.children}
        </Tooltip>
    );
});

TooltipWrapperIssue.propTypes = {
    error: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.object,
};
